import type { Step } from "react-joyride";

export const hrHubTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ HR Self-Service Hub. ທ່ານສາມາດເຂົ້າໃຊ້ບໍລິການລາພັກ, OT, ແລະປະຫວັດເງິນເດືອນໄດ້ຢູ່ນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-hub-cards-grid"]',
    content: "ແຖວການບໍລິການ. ກົດເພື່ອເຂົ້າໄປຫາໜ້າຕ່າງໆ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="hr-hub-recent-activity"]',
    content: "ກວດເບິ່ງລາຍການເຄື່ອນໄຫວຫຼ້າສຸດຂອງທ່ານ.",
    placement: "top",
  },
];

export const leaveRequestListTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າຕິດຕາມຄຳຂໍລາ. ທ່ານສາມາດເບິ່ງສະຖານະ ແລະ ສ້າງຄຳຂໍໃໝ່.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-leave-list-create-button"]',
    content: "ກົດທີ່ນີ້ເພື່ອສ້າງຄຳຂໍລາໃໝ່.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="hr-leave-requests-table"]',
    content: "ຕາຕະລາງຄຳຂໍລາ. ກົດເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];

export const leaveRequestFormTourSteps: Step[] = [
  {
    target: "body",
    content: "ຟອມສ້າງ/ແກ້ໄຂຄຳຂໍລາ. ກຳນົດປະເພດລາ ແລະ ວັນເລີ່ມ–ສິ້ນສຸດ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-leave-type-selector"]',
    content: "ເລືອກປະເພດລາຂອງທ່ານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="hr-leave-submit-button"]',
    content: "ກົດປຸ່ມນີ້ເພື່ອສົ່ງ/ບັນທຶກຄຳຂໍລາ.",
    placement: "top",
  },
];

export const leaveRequestDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍລະອຽດຄຳຂໍລາ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-leave-detail-card"]',
    content: "ເບິ່ງຂໍ້ມູນລາຍລະອຽດ: ວັນເລີ່ມ–ສິ້ນສຸດ, ຈຳນວນວັນ, ແລະສະຖານະ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="hr-leave-detail-edit-button"]',
    content: "ປຸ່ມນີ້ໃຊ້ເພື່ອແກ້ໄຂ (ເມື່ອສະຖານະຍັງລໍຖ້າອະນຸມັດ).",
    placement: "top",
  },
];

export const overtimeRequestListTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າຕິດຕາມຄຳຂໍ OT.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-ot-list-table"]',
    content: "ຕາຕະລາງຄຳຂໍ OT. ກົດເພື່ອເບິ່ງລາຍລະອຽດ.",
    placement: "top",
  },
];

export const overtimeRequestFormTourSteps: Step[] = [
  {
    target: "body",
    content: "ຟອມສ້າງຄຳຂໍ OT. ກຳນົດວັນທີ, ເວລາເລີ່ມ–ສິ້ນສຸດ, ແລະເຫດຜົນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-ot-submit-button"]',
    content: "ກົດປຸ່ມນີ້ເພື່ອສົ່ງຄຳຂໍ OT.",
    placement: "top",
  },
];

export const overtimeRequestDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ນີ້ແມ່ນໜ້າລາຍລະອຽດຄຳຂໍ OT.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-ot-detail-card"]',
    content: "ເບິ່ງຂໍ້ມູນລາຍລະອຽດຂອງ OT.",
    placement: "bottom",
  },
];

export const payrollHistoryTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າປະຫວັດໃບຮັບເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-payroll-history-cards"]',
    content: "ເລືອກໃບຮັບເງິນເດືອນທີ່ຕ້ອງການເພື່ອເບິ່ງ/ດາວໂຫລດ.",
    placement: "top",
  },
];

export const payrollDetailTourSteps: Step[] = [
  {
    target: "body",
    content: "ໜ້າລາຍລະອຽດໃບຮັບເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="hr-payroll-detail-content"]',
    content: "ເນື້ອໃນໃບຮັບເງິນເດືອນ (ສາມາດພິມ/ດາວໂຫລດໄດ້).",
    placement: "top",
  },
];
